import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // use this to navigate to /services
import "./Home.css";
import frontImage from "../assets/frontimag.png";

const Home = () => {
  const [subscribed, setSubscribed] = useState(false);
  const navigate = useNavigate(); // react-router hook

  const handleSubscribe = (e) => {
    e.preventDefault();
    setSubscribed(true);
  };

  const goToServicesPage = () => {
    navigate("/services");
  };

  return (
    <section className="home-section">
      <div className="home-container">
        {/* Left Side */}
        <div className="home-left">
          <h1 className="home-title">Welcome to Next-Gen IT Services</h1>
          <p className="home-subtitle">
            We build innovative and scalable IT solutions to help businesses thrive in a digital world.
          </p>
           <div className="home-button-wrapper">
            <button className="home-button" onClick={goToServicesPage}>
              Explore Our Services
            </button>
          </div>
        </div>

        {/* Right Side */}
        <div className="home-right">
          <img src={frontImage} alt="Tech Visual" className="home-image" />
        </div>
      </div>

      {/* Stats Section */}
      <div className="stats-container">
        <div className="stat-box">
          <div className="stat-number">150+</div>
          <div className="stat-label">Projects Completed</div>
        </div>
        <div className="stat-box">
          <div className="stat-number">100+</div>
          <div className="stat-label">Happy Clients</div>
        </div>
        <div className="stat-box">
          <div className="stat-number">2+</div>
          <div className="stat-label">Years Experience</div>
        </div>
        <div className="stat-box">
          <div className="stat-number">24/7</div>
          <div className="stat-label">Customer Support</div>
        </div>
      </div>

      {/* Newsletter Section */}
      <div className="newsletter">
        <h3>Subscribe to Our Newsletter</h3>
        {!subscribed ? (
          <form className="newsletter-form" onSubmit={handleSubscribe}>
            <input type="text" placeholder="Your Name" required />
            <input type="email" placeholder="Your Email" required />
            <button type="submit">Subscribe</button>
          </form>
        ) : (
          <p className="thank-you">✅ Thanks for subscribing!</p>
        )}
      </div>
    </section>
  );
};

export default Home;
